import React, { useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import { Card, Button, Tag, Modal, message, Switch } from "antd";
import Table from "../../../common/components/Table";
import { RxDownload } from "react-icons/rx";
import { getCounsellorList } from "../../api/Data/Counsellor";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { updateCounsellor } from "../../api/Update/Counsellor";

export default function CounsellorList(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [selectedName, setSelectedName] = useState(null);
  const [messageUser, setMessage] = useState(null);
  const [type, setType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [data, setData] = useState([]);

  const getStudentLists = () => {
    const token = localStorage.getItem("token");
    dispatch(getCounsellorList("Bearer " + token)).then((res) => {
      if (Array.isArray(res.payload.data.payload.data)) {
        setData(res.payload.data.payload.data);
      }
    });
  };

  const studentUpdate = (actionType) => {
    const newStatus = actionType === "Activate" ? "ACTIVE" : "INACTIVE";
    const userData = {
      status: newStatus,
      id: selectedId,
    };

    dispatch(updateCounsellor(userData)).then((res) => {
      if (res.payload.status === "success") {
        getStudentLists();
        props.getStudentListsData();
        message.success("Counsellor Updated Successfully");
      } else if (res.payload.message.error === "invalid_token") {
        message.error("Session expired. Please login again");
        window.location.href = "/";
      } else {
        message.error("Something went wrong");
      }
    });
  };

  const downloadList = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, "table-data.xlsx");
  };

  const showModal = () => {
    setShow(true);
  };

  const handleOk = () => {
    setShow(false);
    studentUpdate(type);
  };

  const handleCancel = () => {
    setShow(false);
  };

  const doAction = (record) => {
    setSelectedName(record.firstName);
    setSelectedId(record.pcUserId);

    if (record.status === "ACTIVE") {
      setMessage("Are you sure you want to Deactivate ");
      setType("Deactivate");
    } else {
      setMessage("Are you sure you want to Activate ");
      setType("Activate");
    }

    showModal();
  };

  useEffect(() => {
    getStudentLists();
  }, []);

  const columns = [
    {
      title: "Practitioner Name",
      key: "name",
      render: (_, record) => <>{record.firstName}</>,
    },
    {
      title: "Email ID",
      key: "email",
      render: (_, record) => <>{record.email}</>,
    },
    {
      title: "Mobile No.",
      key: "mobile",
      render: (_, record) => <>{record.mobile}</>,
    },
    {
      title: "Available Day",
      key: "availableDay",
      render: (_, record) => (
        <>
          {record.availableDay?.length > 0 ? (
            <div style={{ display: "flex" }}>
              {record.availableDay.map((item, index) => (
                <div
                  key={index}
                  style={{
                    width: "30px",
                    height: "30px",
                    background: "#2563EB",
                    borderRadius: "30px",
                    marginLeft: "2px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF",
                    fontSize: "12px",
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          ) : (
            <Tag color="red">Not Available</Tag>
          )}
        </>
      ),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => <>{record.specialization}</>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        localStorage.getItem("role") === "ADMIN" ? (
          <Switch
            checked={record.status !== "ACTIVE"}
            onClick={() => doAction(record)}
            style={{
              backgroundColor:
                record.status === "ACTIVE" ? "#009F41" : "#FC5150",
            }}
          />
        ) : null,
    },
  ];

  return (
    <Box style={{ marginTop: "8px" }}>
      <Grid md={12} style={{ marginTop: "0px" }}>
        <Card
          title={<span className="text-base font-semibold text-[#171717] font-poppins">Practitioner List</span>}
          extra={
            <Button
              className="btn-gradient flex items-center gap-2 h-9 px-[14px] text-[13px] font-semibold rounded-xl border-0 font-poppins"
              onClick={downloadList}
            >
              Download <RxDownload color="#FFFFFF" />
            </Button>
          }
          className="mt-3 rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm font-poppins"
        >
          <Table
            col={columns}
            data={data}
            placeholder={"Search Practitioner..."}
            showFilter={true}
          />
        </Card>
      </Grid>

      <Modal open={show} onCancel={handleCancel} footer={null} centered>
        <p className="modal-message text-base text-[#334155] font-poppins mt-4 mb-1 text-center">{messageUser}</p>
        <p className="modal-name text-xl font-semibold text-[#171717] font-poppins mb-4 text-center">{selectedName} ?</p>
        <div className="modal-footer flex gap-4 border-0 p-0">
          <Button
            className="modal-cancel-btn flex-1 h-auto py-3 border-[1px] border-solid border-[#E2E8F0] rounded-xl text-base font-semibold text-[#334155] bg-white hover:bg-gray-50 font-poppins"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="modal-action-btn flex-1 h-auto py-3 btn-gradient rounded-xl text-base font-semibold border-0 font-poppins"
            onClick={handleOk}
          >
            {type}
          </Button>
        </div>
      </Modal>
    </Box>
  );
}
